import profileIcon from "#/assets/exam-results/profile.svg?url";
import MontaIcon from "#/assets/origins/source-monta.svg?url";
import { useSelectedStudentIdContext } from "#/components/exam-results/context/studentsList/context";
import { QLevel } from "#/components/exam-results/question";
import { Tooltip } from "@monta/design-system";
import { env } from "@monta/env";
import { Boy } from "@monta/icons";
import type { DqGlobalProps } from "../types";
import { getDifficultyLevel, getOriginById, useGetQuestions } from "../utils";
import styles from "./dqSidebar.module.scss";

export const DescriptiveQuestionSidebar = (props: DqGlobalProps) => {
  const { id } = props;
  const { selectedStudentId } = useSelectedStudentIdContext();
  const { authorInfo, difficultyLevelId, origins } = useGetQuestions(
    selectedStudentId,
    id,
  )[0];

  const level = getDifficultyLevel(difficultyLevelId);

  const parsedPersonInfoList =
    JSON.parse(authorInfo ?? "{}")?.personInfoList ?? [];

  const parsedQuestionOriginList =
    JSON.parse(origins ?? "{}")?.questionOriginList ?? [];

  const questionOrigins = parsedQuestionOriginList.map((origin) => {
    if (origin.originId === 10) {
      const personInfo = parsedPersonInfoList[0];
      if (personInfo) {
        return {
          ...origin,
          ...personInfo,
          icon: personInfo.imageId
            ? {
                type: "img",
                value: `${env.GWT_URL}/render?id=${personInfo.imageId}`,
              }
            : {
                type: "defaultIcon",
                value: profileIcon,
              },
          style: { borderRadius: "50%" },
        };
      }

      return {
        icon: {
          type: "img",
          value: MontaIcon,
        },
        name: "منتا",
        style: { borderRadius: "50%" },
      };
    }

    const originInfo = getOriginById(origin.originId);

    return {
      ...origin,
      ...originInfo,
    };
  });

  return (
    <aside className={styles["dq-sidebar"]}>
      <div className={styles["dq-sidebar__origins-container"]}>
        {questionOrigins?.length < 2 && (
          <>
            {questionOrigins?.[0]?.icon.type === "img" && (
              <img
                className={
                  styles["dq-sidebar__origins-container__single-profile-photo"]
                }
                src={questionOrigins?.[0]?.icon?.value}
                alt={questionOrigins?.[0]?.name}
                style={questionOrigins?.[0]?.style ?? {}}
              />
            )}

            {questionOrigins?.[0]?.icon.type === "defaultIcon" && (
              <Boy
                className={
                  styles["dq-sidebar__origins-container__single-profile-photo"]
                }
              />
            )}

            <div
              className={
                styles["dq-sidebar__origins-container__single-profile-name"]
              }
            >
              <span>{questionOrigins?.[0]?.name}</span>
              <span>{`${questionOrigins?.[0]?.publishYear ? `${questionOrigins?.[0]?.publishYear} - ${questionOrigins?.[0]?.publishYear - 1}` : ""}`}</span>
            </div>
          </>
        )}
        {questionOrigins.length >= 2 && (
          <>
            <div
              className={styles["dq-sidebar__origins-container__multi-profile"]}
            >
              <span>{questionOrigins?.length} مرجع</span>
              <Tooltip
                text={questionOrigins
                  ?.map(
                    (origin, index) =>
                      ` ${origin.name} ${questionOrigins[index]?.publishYear} - ${questionOrigins[index]?.publishYear - 1} `,
                  )
                  .join("|")}
                position="right"
              >
                <img src={questionOrigins?.[0]?.icon?.value} alt="" />
              </Tooltip>
            </div>
          </>
        )}
      </div>
      <div className={styles["dq-sidebar__difficulty-level"]}>
        <QLevel level={level.code} />
        <div>{level.label}</div>
      </div>
    </aside>
  );
};
